import { Card } from "antd";
import { Products } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function OrderPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Products", href: "/products" },
          { title: "Details", href: `/products/view/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Product Details</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Card bordered={false}>
            <Products.View productId={id} />
          </Card>
        </div>
      </div>
    </div>
  );
}
